import { render, staticRenderFns } from "./BackgroundImageEditor.vue?vue&type=template&id=5d6740e4&"
import script from "./BackgroundImageEditor.vue?vue&type=script&lang=ts&"
export * from "./BackgroundImageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundImageEditor.vue?vue&type=style&index=0&id=5d6740e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports